// import React from 'react';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumbs } from '../navigation/Breadcrumbs';
import { UserProfile } from './UserProfile';
import PRtrack_F0F0F0 from '../../../assets/PRtrack_F0F0F0.png';

interface LayoutProps {
  children: ReactNode;
  backgroundColor?: string;
}

export const Layout = ({ children, backgroundColor = 'bg-brand-white' }: LayoutProps) => {
  return (
    <div className={`min-h-screen ${backgroundColor}`}>
      <nav className="bg-brand-black text-brand-white">
        <div className="mx-auto px-4 sm:px-6 lg:px-2 max-w-[99%]">
          <div className="flex h-16 items-center justify-between">
            <div className="flex items-center gap-8">
              <div className="flex-shrink-0 flex items-center gap-4">
                <Link to="/" className="flex items-center">
                  <img
                    src={PRtrack_F0F0F0}
                    alt="PR Track Logo"
                    className="h-8 w-auto object-contain hover:opacity-80 transition-opacity cursor-pointer"
                  />
                </Link>
                {/* <Link to="/" className="text-xl font-bold">
                  Track
                </Link> */}
              </div>
              <Breadcrumbs />
            </div>
            <UserProfile />
          </div>
        </div>
      </nav>

      <main className="mx-auto px-4 sm:px-6 lg:px-2 py-3 max-w-[99%]">{children}</main>
    </div>
  );
};
